import React from 'react'
import HomePageTable from '../../../components/HomePageTable'
import { useAppSelector } from '../../../State/Store'

export const DealCategoryTable = () => {
   const {homeCategory} = useAppSelector(store=>store)
  return (
    <div>
        <HomePageTable data={homeCategory.homePageData?.dealCategories}/>
    </div>
  )
}
